import React from 'react'

import classes from './ImportModal.scss'

import Modal from '../../../UI/Modal/Modal'
import Footer from './Footer/Footer'

import InputGroup from '../../../UI/Forms/InputGroup/InputGroup'
import { withTranslate } from 'react-redux-multilingual'

const importModal = ({ open, cancelled, fileChanged, fileSubmit, selectedFile, translate }) => {
  return (
    <Modal
      open={open}
      onHide={cancelled}
      header={translate('import') + translate('employee')}
      size={'xs'}
      footer={<Footer onSave={fileSubmit} onHide={cancelled} saveDisabled={!selectedFile} />}>
      <div className={classes.ModalBody}>
        <InputGroup
          label={translate('import') + translate('file')}
          inputValue={selectedFile}
          inputType={'file'}
          changed={fileChanged}
          configs={{ placeholder: translate('select') + translate('file') }}
        />
      </div>
    </Modal>
  )
}

export default withTranslate(importModal)
